/* IMPORT */
import isObservableBoolean from './is_observable_boolean.js';
import isObservableFrozen from './is_observable_frozen.js';
import isUntracked from './is_untracked.js';
import memo from './memo.js';
import { SYMBOL_OBSERVABLE_BOOLEAN } from '../symbols.js';
import { isFunction } from '../utils.js';
/* MAIN */
const boolean = (value) => {
    if (isFunction(value)) {
        if (isObservableFrozen(value) || isUntracked(value)) {
            return !!value();
        }
        else if (isObservableBoolean(value)) {
            return value;
        }
        else {
            const boolean = memo(() => !!value());
            boolean[SYMBOL_OBSERVABLE_BOOLEAN] = true;
            return boolean;
        }
    }
    else {
        return !!value;
    }
};
/* EXPORT */
export default boolean;
